import React from "react";
import "./UserAvatar.css";

/**
 * UserAvatar Component
 * Shows profile photo or user initials if photo is not available
 */
const UserAvatar = ({
  user,
  size = "medium",
  className = "",
  showBorder = false,
  borderColor = "#4f46e5",
}) => {
  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const sizeClasses = {
    small: "user-avatar-small",
    medium: "user-avatar-medium",
    large: "user-avatar-large",
  };

  const sizeClass = sizeClasses[size] || sizeClasses.medium;

  // If user has profile photo, show it
  if (user?.profilePhotoUrl) {
    return (
      <img
        src={user.profilePhotoUrl}
        alt={user.name || "User"}
        className={`user-avatar ${sizeClass} ${
          showBorder ? "with-border" : ""
        } ${className}`}
        style={showBorder ? { borderColor } : {}}
      />
    );
  }

  // Otherwise show initials
  return (
    <div
      className={`user-avatar-initials ${sizeClass} ${
        showBorder ? "with-border" : ""
      } ${className}`}
      style={showBorder ? { borderColor } : {}}
    >
      {getInitials(user?.name)}
    </div>
  );
};

export default UserAvatar;
